"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _MediaSource = require("./MediaSource.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _constants = require("../../constants");
var MediaSource = function MediaSource(_ref) {
  var _ref$source = _ref.source,
    title = _ref$source.title,
    type = _ref$source.type;
  var getIcon = function getIcon() {
    switch (type) {
      case _constants.CAMERA_PRESENTER:
        return _freeSolidSvgIcons.faUser;
      case _constants.SCREEN_PRESENTER:
        return _freeSolidSvgIcons.faTv;
      case _constants.MEDIA:
        return _freeSolidSvgIcons.faPhotoVideo;
      default:
        return _freeSolidSvgIcons.faPhotoVideo;
    }
  };
  return _react["default"].createElement(_MediaSource.Wrapper, null, _react["default"].createElement(_MediaSource.StyledIcon, {
    icon: getIcon()
  }), _react["default"].createElement(_MediaSource.Title, null, title));
};
var _default = exports["default"] = MediaSource;